import {
  type CommandProps,
  isNodeActive,
  mergeAttributes,
  Node,
} from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    customSection: {
      setCustomSection: (className?: string) => ReturnType;
      toggleCustomSection: (className?: string) => ReturnType;
      unsetCustomSection: () => ReturnType;
    };
  }
}

/** block used to tell the document generation pipeline that this is a template string. This extension works well enough for support to use but is not in a good enough state to be used in the main application.*/
export const TemplateStringBlock = Node.create({
  name: "templateString",
  group: "block",
  content: "inline*",
  defining: true,
  isolating: true,

  addAttributes() {
    return {
      class: {
        default: "template-string",
        parseHTML: (element) => element.getAttribute("class"),
        renderHTML: (attributes) => ({ class: attributes.class }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div",
        getAttrs: (element) =>
          element instanceof HTMLElement &&
          element.classList.contains("template-string")
            ? {}
            : false,
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes), 0];
  },

  addCommands() {
    return {
      setCustomSection:
        (className = "template-string") =>
        ({ commands }: CommandProps) => {
          return commands.setNode(this.name, { class: className });
        },

      toggleCustomSection:
        (className = "template-string") =>
        ({ commands, state }: CommandProps) => {
          if (isNodeActive(state, this.name)) {
            return commands.setNode("paragraph");
          }
          return commands.setNode(this.name, { class: className });
        },

      unsetCustomSection:
        () =>
        ({ commands }: CommandProps) => {
          return commands.setNode("paragraph");
        },
    };
  },
});
